module.exports = __webpack_public_path__ + "static/media/cruise-view.78dcc247.jpeg";